import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DataSharingService } from 'src/app/_services/data-sharing.service';
import { HttpRequestService } from 'src/app/_services/http-request.service';

@Component({
  selector: 'ppr-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  form: FormGroup;
  errors: any;
  passwordSaveOK: boolean = false;
  user: any;
  wb: any;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpRequestService,
    private dataSharingService: DataSharingService
  ) { }

  ngOnInit() {
    this.getUser();
    this.setupForm();
    this.setWhiteBranding();
  }

  private setWhiteBranding() {
    this.dataSharingService.whiteBranding.subscribe(res => {
      if (res) {
        this.wb = res;
      }
    });
  }

  private getUser() {
    this.dataSharingService.user.subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
  }

  setupForm() {
    this.form = this.formBuilder.group({
      oldPwd: [null, Validators.required],
      newPwd: [null, Validators.required],
      confirmPwd: [null, Validators.required]
    });
  }

  changePassword() {
    let oldPwd = this.form.controls['oldPwd'].value;
    let newPwd = this.form.controls['newPwd'].value;
    let confirmPwd = this.form.controls['confirmPwd'].value;

    if (newPwd !== confirmPwd) {
      this.errors = "change_password_modal.error_different";
      return;
    }

    let data = {
      oldPassword: oldPwd,
      newPassword: newPwd
    };

    this.http.changePassword(data, this.user.category).toPromise()
      .then(res => {
        this.form.reset();
        this.errors = null;
        this.passwordSaveOK = true;
      })
      .catch(error => {
        this.errors = "change_password_modal.error";
        console.error('Error updating password', error);
      });
  }

  closeDialog() {
    this.form.reset();
    this.errors = null;
    this.passwordSaveOK = false;
  }
}
